import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-71b1f90f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "square-buttons" }
const _hoisted_2 = { class: "square-end-buttons" }
const _hoisted_3 = { class: "circular-border" }
const _hoisted_4 = {
  key: 0,
  class: "circle-buttons"
}
const _hoisted_5 = {
  key: 1,
  class: "circle-buttons-skeleton"
}
const _hoisted_6 = {
  key: 2,
  class: "info"
}
const _hoisted_7 = { class: "establishment-name" }
const _hoisted_8 = { id: "tags" }
const _hoisted_9 = {
  key: 3,
  class: "info-skeleton"
}
const _hoisted_10 = { class: "content" }
const _hoisted_11 = {
  key: 0,
  class: "highlights"
}
const _hoisted_12 = { class: "title-line" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title" }, "Principais cupons", -1))
const _hoisted_14 = { class: "central-button" }
const _hoisted_15 = {
  key: 1,
  class: "highlights"
}
const _hoisted_16 = { class: "title-line" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title" }, "Principais ofertas", -1))
const _hoisted_18 = { class: "central-button" }
const _hoisted_19 = {
  key: 2,
  class: "warning"
}
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_skeleton_text = _resolveComponent("ion-skeleton-text")!
  const _component_store_external_logo = _resolveComponent("store-external-logo")!
  const _component_badge = _resolveComponent("badge")!
  const _component_coupons_cards = _resolveComponent("coupons-cards")!
  const _component_offers_cards = _resolveComponent("offers-cards")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, { ref: "content" }, {
        default: _withCtx(() => [
          (!$data.loading)
            ? (_openBlock(), _createElementBlock("header", {
                key: 0,
                style: _normalizeStyle({
          backgroundImage: $data.store.background
            ? `url(${$data.store.background})`
            : 'url(https://cdn.thelivery.com.br/img/explore/background/default-background.jpg)',
        })
              }, [
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_component_ion_button, {
                    class: "button-header",
                    fill: "clear",
                    onClick: $setup.goBack
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        icon: $setup.arrowBack,
                        color: "light"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_ion_button, {
                      class: "button-header",
                      fill: "clear",
                      onClick: $options.likeStore
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, {
                          icon: $setup.heart,
                          color: $data.store.liked ? 'primary' : 'light'
                        }, null, 8, ["icon", "color"])
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_ion_button, {
                      class: "button-header",
                      fill: "clear",
                      onClick: $options.shareEstablishment
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, {
                          icon: $setup.share,
                          color: "light"
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ])
              ], 4))
            : (_openBlock(), _createBlock(_component_ion_skeleton_text, {
                key: 1,
                class: "header-skeleton",
                animated: ""
              })),
          _createElementVNode("div", _hoisted_3, [
            (!$data.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_store_external_logo, {
                    logo: $data.store.logo,
                    "w-h": "120px"
                  }, null, 8, ["logo"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_ion_skeleton_text, {
                    class: "circle-button-skeleton",
                    animated: ""
                  }),
                  _createVNode(_component_ion_skeleton_text, {
                    class: "ion-avatar-skeleton",
                    animated: ""
                  }),
                  _createVNode(_component_ion_skeleton_text, {
                    class: "circle-button-skeleton",
                    animated: ""
                  })
                ])),
            (!$data.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("h3", _hoisted_7, _toDisplayString($data.store.name), 1),
                  _createElementVNode("div", _hoisted_8, [
                    ($data.store.cashback)
                      ? (_openBlock(), _createBlock(_component_badge, {
                          key: 0,
                          text: $data.store.cashback + '% cashback',
                          color: "#C6FAF8",
                          class: "tag"
                        }, null, 8, ["text"]))
                      : _createCommentVNode("", true),
                    ($data.store.number_coupons)
                      ? (_openBlock(), _createBlock(_component_badge, {
                          key: 1,
                          text: 
                $data.store.number_coupons > 1
                  ? $data.store.number_coupons + ' Cupons'
                  : $data.store.number_coupons + ' Cupom'
              ,
                          color: "#FBEBAF",
                          class: "tag"
                        }, null, 8, ["text"]))
                      : _createCommentVNode("", true),
                    ($data.store.number_offers)
                      ? (_openBlock(), _createBlock(_component_badge, {
                          key: 2,
                          text: 
                $data.store.number_offers > 1
                  ? $data.store.number_offers + ' Ofertas'
                  : $data.store.number_offers + ' Oferta'
              ,
                          color: "#FF9AE3",
                          class: "tag"
                        }, null, 8, ["text"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(_component_ion_button, {
                      shape: "round",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.goToStore()))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString($data.store.button_text || "Ir para a loja"), 1)
                      ]),
                      _: 1
                    })
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createVNode(_component_ion_skeleton_text, {
                    class: "establishment-name-skeleton",
                    animated: ""
                  }),
                  _createVNode(_component_ion_skeleton_text, {
                    class: "order-info-skeleton",
                    animated: ""
                  }),
                  _createVNode(_component_ion_skeleton_text, { animated: "" })
                ])),
            _createElementVNode("div", _hoisted_10, [
              ($data.coupons.length > 0)
                ? (_openBlock(), _createElementBlock("section", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _hoisted_13,
                      _createElementVNode("a", {
                        class: "more-items",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => ($options.goToRelative('/cupons')))
                      }, "Ver tudo")
                    ]),
                    _createVNode(_component_coupons_cards, { items: $data.coupons }, null, 8, ["items"]),
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_ion_button, {
                        shape: "round",
                        fill: "outline",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => ($options.goToRelative('/cupons')))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Ver todos os cupons ")
                        ]),
                        _: 1
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              ($data.offers.length > 0)
                ? (_openBlock(), _createElementBlock("section", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _hoisted_17,
                      _createElementVNode("a", {
                        class: "more-items",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => ($options.goToRelative('/ofertas')))
                      }, "Ver tudo")
                    ]),
                    _createVNode(_component_offers_cards, { items: $data.offers }, null, 8, ["items"]),
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_ion_button, {
                        shape: "round",
                        fill: "outline",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => ($options.goToRelative('/ofertas')))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Ver todas as ofertas ")
                        ]),
                        _: 1
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (!$data.loading)
                ? (_openBlock(), _createElementBlock("section", _hoisted_19, [
                    ($data.warning)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          _createElementVNode("h4", null, _toDisplayString($data.warning.title), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.warning.content, (content, i) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: i,
                              class: "external-store-info"
                            }, [
                              _createElementVNode("p", null, _toDisplayString(content), 1)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    ($data.about)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          _createElementVNode("h4", null, _toDisplayString($data.about.title), 1),
                          _createElementVNode("ul", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.about.content, (content, i) => {
                              return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(content), 1))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _: 1
      }, 512)
    ]),
    _: 1
  }))
}